import { render, staticRenderFns } from "./PolicyOverallReturn.vue?vue&type=template&id=a99d5222&"
import script from "./PolicyOverallReturn.vue?vue&type=script&lang=ts&"
export * from "./PolicyOverallReturn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports